var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(!_vm.loading)?_c('student-form',{on:{"save":_vm.save,"back":_vm.back},model:{value:(_vm.entity),callback:function ($$v) {_vm.entity=$$v},expression:"entity"}}):_c('loading-page')],1)}
var staticRenderFns = []

export { render, staticRenderFns }